<template>
  <div>
    <div class="d-flex justify-space-between card-header">
      <div class="card-header--body">
        <p class="overline mb-1">{{ el.name }}</p>
        <div
          v-if="!attrs.details"
          class="pre-wrap text-body-1 black--text"
          v-html="el.challenge"
        ></div>
      </div>

      <div class="circle" :style="{ backgroundColor: getColor(el.priority) }">
        {{ el.priority }}
      </div>
    </div>
    <article v-show="attrs.details" v-if="el.challenge">
      <p class="text-caption text-uppercase my-2">Challenge</p>
      <div class="pre-wrap text-body-1 black--text" v-html="el.challenge"></div>
    </article>

    <article v-show="attrs.details" v-if="el.body">
      <p class="text-caption text-uppercase my-2">Context</p>
      <div class="pre-wrap" v-html="el.body"></div>
    </article>
    <article v-show="attrs.details" v-if="el.points">
      <ul>
        <li v-for="point in el.points" :key="point.id">
          {{ point }}
        </li>
      </ul>
    </article>

    <article v-show="attrs.tags" v-if="isVisible(el.categories)">
      <p class="text-caption text-uppercase mb-2 mt-2">Categories</p>
      <div class="d-flex flex-wrap">
        <v-chip
          v-for="(tag, index) in el.categories"
          light
          :key="`tag-nested-category-${tag}-${index}-${el.id}`"
          small
          class="mr-1 mb-1 yellow lighten-3"
        >
          {{ tag }}</v-chip
        >
      </div>
    </article>

    <article v-show="attrs.tags" v-if="isVisible(el.tags)">
      <p class="text-caption text-uppercase mb-2 mt-2">Tags</p>
      <div class="d-flex flex-wrap">
        <v-chip
          v-for="(tag, index) in el.tags"
          :key="`tag-nested-asset-tag-${tag}-${index}-${el.id}`"
          small
          light
          class="mr-1 mb-1 yellow-lighten-5"
          color="green lighten-3"
        >
          {{ tag }}</v-chip
        >
      </div>
    </article>

    <article v-show="attrs.tags" v-if="isVisible(el.themes)">
      <p class="text-caption text-uppercase mb-2 mt-2">Themes</p>
      <div class="d-flex flex-wrap">
        <v-chip
          v-for="(tag, index) in el.themes"
          :key="`tag-nested-asset-themes-${tag}-${index}-${el.id}`"
          small
          light
          class="mr-1 mb-1 yellow-lighten-5"
          color="blue lighten-3"
        >
          {{ tag }}</v-chip
        >
      </div>
    </article>
    <v-chip small v-if="el.disabled" color="red" class="mt-4 white--text"
      >Disabled</v-chip
    >
  </div>
</template>

<script>
export default {
  name: "ChallengeCard",
  props: {
    el: {
      type: Object,
      default: () => {},
    },
    attrs: {
      type: Object,
      default: () => {},
    },
    local: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    isVisible(arr) {
      return arr && arr.length >= 1;
    },
    getColor(priority) {
      switch (priority) {
        case 1:
          return "green";
        case 2:
          return "orange";
        case 3:
          return "red";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  display: flex;
  p {
    flex: 1;
  }
  &--body {
    width: 90%;
  }
}
.circle {
  width: 30px;
  height: 30px;
  background: grey;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
}
</style>
